import { Outlet } from '@tanstack/react-router';
import AsyncPageContainer from '_/common/components/layout/AsyncPageContainer';
import React, { ReactElement } from 'react';

function ExtractorsContainer(): ReactElement {
  return (
    <AsyncPageContainer isLoading={false}>
      <Outlet />
    </AsyncPageContainer>
  );
}

export default ExtractorsContainer;
